import { render, staticRenderFns } from "./GreenGoodDesignAwardForm.vue?vue&type=template&id=2bc1eecb"
import script from "./GreenGoodDesignAwardForm.vue?vue&type=script&lang=js"
export * from "./GreenGoodDesignAwardForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/home/bazzite/Work/awardapplication/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bc1eecb')) {
      api.createRecord('2bc1eecb', component.options)
    } else {
      api.reload('2bc1eecb', component.options)
    }
    module.hot.accept("./GreenGoodDesignAwardForm.vue?vue&type=template&id=2bc1eecb", function () {
      api.rerender('2bc1eecb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/green-good-design-award/components/GreenGoodDesignAwardForm.vue"
export default component.exports